import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const AccountSettingsIcon = (props) => {
  const { className, ...rest } = props;
  const classes = clsx('custom-icon', className);

  return (
    <svg width="25" height="24" data-type="fill" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={classes} {...rest}>
      <path d="M5.1225 2C5.1225 1.45 4.6725 1 4.1225 1C3.5725 1 3.1225 1.45 3.1225 2V6H1.1225V12H7.1225V6H5.1225V2ZM9.1225 16C9.1225 17.3 9.9625 18.4 11.1225 18.82V23H13.1225V18.82C14.2825 18.41 15.1225 17.31 15.1225 16V14H9.1225V16ZM1.1225 16C1.1225 17.3 1.9625 18.4 3.1225 18.82V23H5.1225V18.82C6.2825 18.4 7.1225 17.3 7.1225 16V14H1.1225V16ZM21.1225 6V2C21.1225 1.45 20.6725 1 20.1225 1C19.5725 1 19.1225 1.45 19.1225 2V6H17.1225V12H23.1225V6H21.1225ZM13.1225 2C13.1225 1.45 12.6725 1 12.1225 1C11.5725 1 11.1225 1.45 11.1225 2V6H9.1225V12H15.1225V6H13.1225V2ZM17.1225 16C17.1225 17.3 17.9625 18.4 19.1225 18.82V23H21.1225V18.82C22.2825 18.41 23.1225 17.31 23.1225 16V14H17.1225V16Z" />
    </svg>
  );
};

AccountSettingsIcon.defaultProps = {
  className: '',
};

AccountSettingsIcon.propTypes = {
  className: PropTypes.string,
};

export default AccountSettingsIcon;
